import RestHelper from '../utils/RestHelper';

function getSearchData(endpoint) {
  return RestHelper.get(endpoint);
}

export const getORTDataRequestSuccess = (dispatch, response) => {
  dispatch({
    type: 'GET_RESULTS_SUCCESSFUL',
    data: {
      ORTresponse: response.data
    }
  });
};

export const getSearchContactsSuccess = (dispatch, response) => {
  dispatch({
    type: 'GET_RESULTS_SUCCESSFUL',
    data: {
      searchContactsResponse: response.data
    }
  });
};

export const resultsRequestStarted = (dispatch) => {
  dispatch({
    type: 'GET_RESULTS_STARTED'
  });
};

export const resultsRequestError = (dispatch, error) => {
  dispatch({
    type: 'GET_RESULTS_ERROR',
    data: {
      error
    }
  });
};

export const getPlaceDataByZipCode = (dispatch, endpoint) => {
  const resp = getSearchData(endpoint);
  resultsRequestStarted(dispatch);
  return resp
    .then((response) => {
      getORTDataRequestSuccess(dispatch, response);
    })
    .catch((err) => {
      resultsRequestError(dispatch, err);
      console.error('getPlaceDataByZipCode', err); // eslint-disable-line no-console
    });
};

export const searchContactsByZipcodePlaceDistrict = (dispatch, endpoint) => {
  const resp = getSearchData(endpoint);
  resultsRequestStarted(dispatch);
  return resp
    .then((response) => {
      getSearchContactsSuccess(dispatch, response);
    })
    .catch((err) => {
      resultsRequestError(dispatch, err);
      console.error('searchContactsByZipcodePlaceDistrict', err); // eslint-disable-line no-console
    });
};

export default function reducer(state = {}, action = {}) {
  switch (action.type) {
    case 'GET_RESULTS_STARTED': {
      return Object.assign({}, state, action.data, { isRequestPending: true });
    }
    case 'GET_RESULTS_SUCCESSFUL': {
      return Object.assign({}, state, action.data, {
        isRequestPending: false,
        isSuccess: true
      });
    }
    case 'GET_RESULTS_ERROR': {
      return Object.assign({}, state, action.data, {
        isRequestPending: false,
        isSuccess: false
      });
    }
    default:
      return state;
  }
}

